<template>
  <footer class="app-footer">
  	<div>© 2019 xpressbees.</div>
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue?b1b53a80